<script>
export default {
  name: "TitleVue",
  props: ["title"],
  render() {
    return null;
  },
};
</script>
